<p-toast></p-toast>
<div class="bank-details-container mt-2">

    <!-- Visible on Small screens -->
    <div class="block md:hidden">
        <div class="flex align-items-center justify-content-between">
            <h5 class="mt-3">{{'FINANCE_DETAILS_OF_REQUEST'| translate}}</h5>
            <p-button [icon]="canEditFinanceDetails ? saveIcon : editIcon" class="p-button-info"
                (click)="toggleEditFinanceDetails()"></p-button>
        </div>
        <p-card styleClass="p-card-shadow my-2" *ngFor="let item of physicalVerficationBilledData; let i = index">
            <!-- <table cellspacing="1"> -->
            <table cellspacing="10">
                <tr>
                    <td><b>{{'PROGRAMME_NAME'| translate}}</b></td>
                    <td>
                        {{item?.ProgrammeName}}
                    </td>
                </tr>
                <tr>
                    <td><b>{{'COMPONENT_ID'| translate}}</b></td>
                    <td>
                        {{item?.CompId}}
                    </td>
                </tr>
                <tr>
                    <td><b>{{'CAT_ID'| translate}}</b></td>
                    <td>
                        {{item?.CatId}}
                    </td>
                </tr>
                <tr>
                    <td><b>{{'SIZE_ID'| translate}}</b></td>
                    <td>
                        {{item?.SizeId}}
                    </td>
                </tr>
                <tr>
                    <td><b>{{'COMPONENT_NAME'| translate}}</b></td>
                    <td>
                        {{item?.component}}
                    </td>
                </tr>
                <tr>
                    <td><b>{{'SIZE'| translate}}</b></td>
                    <td>
                        {{item?.size}}
                    </td>
                </tr>
                <tr>
                    <td><b>{{'PRICE'| translate}}</b></td>
                    <td>
                        {{item?.Price}}
                    </td>
                </tr>
                <tr>
                    <td><b>{{'ESTIMATED_QUANTITY'| translate}}</b></td>
                    <td>
                        {{item?.EstimatedQuantity}}
                    </td>
                </tr>
                <tr>
                    <td><b>{{'BILLED_QUANTITY'| translate}}</b></td>
                    <td>
                        {{item?.BilledQuantity}}
                    </td>
                </tr>
                <tr>
                    <td><b>{{'ACTUAL_QUANTITY'| translate}}</b></td>
                    <td>
                        <input #actualQuantity type="text" pInputText [value]="item?.ActualQuantity"
                            [readonly]="!canEditFinanceDetails" style="width: 70%;"
                            [style.border]="canEditFinanceDetails ? '' : 'none'"
                            (input)="changeActualQuantity(item, $event, i)" required>
                        <br>
                        <small class="p-error" *ngIf="greaterThan(actualQuantity.value, item?.BilledQuantity)">{{'ACTUAL_QUANTITY_CANNOT_BE_MORE_THAN_BILLED_QUANTITY'| translate}}</small>
                    </td>
                </tr>
                <tr>
                    <td><b>{{'TOTAL_AMOUNT'| translate}}</b></td>
                    <td>
                        {{item?.ActualQuantity ? (item?.ActualQuantity * item?.Price) : 0}}
                    </td>
                </tr>
            </table>
        </p-card>
    </div>




    <!-- Hidden on small screens -->
    <div class="hidden md:block">
        <p-card styleClass="p-card-shadow" class="dashboardTable">
            <h5 class="mt-0">{{'FINANCE_DETAILS_OF_REQUEST'| translate}}</h5>
            <div>
                <!-- <p-toolbar styleClass="mb-4">
                    <ng-template pTemplate="left">
                        <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                            class="p-button-success"></button>
                    </ng-template>
                    <ng-template pTemplate="right">
                        <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-upload"
                            class="p-button-help"></button>
                        <p-menu #menu [popup]="true" [model]="items"></p-menu>
                    </ng-template>
    
                </p-toolbar> -->

                <p-table #dt [value]="physicalVerficationBilledData" [rows]="10" [paginator]="true"
                    [globalFilterFields]="['ProgrammeName','CompId','CatId','SizeId', 'component', 'size', 'Price', 'EstimatedQuantity', 'BilledQuantity']"
                    responsiveLayout="scroll" [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [showCurrentPageReport]="true">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            <h5 class="m-0">{{'MANAGE_BILLED_COMPONENT_DETAILS'| translate}}</h5>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="Search..." />
                            </span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="ProgrammeName">{{'PROGRAMME_NAME'| translate}}
                                <p-columnFilter type="text" field="ProgrammeName" display="menu"></p-columnFilter>
                                <p-sortIcon field="ProgrammeName"></p-sortIcon>
                            </th>
                            <th pSortableColumn="CompId">{{'COMPONENT_ID'| translate}}
                                <p-columnFilter type="text" field="CompId" display="menu"></p-columnFilter>
                                <p-sortIcon field="CompId"></p-sortIcon>
                            </th>
                            <th pSortableColumn="CatId">{{'CAT_ID'| translate}}
                                <p-columnFilter type="text" field="CatId" display="menu"></p-columnFilter>
                                <p-sortIcon field="CatId"></p-sortIcon>
                            </th>
                            <th pSortableColumn="SizeId">{{'SIZE_ID'| translate}}
                                <p-columnFilter type="text" field="SizeId" display="menu"></p-columnFilter>
                                <p-sortIcon field="SizeId"></p-sortIcon>
                            </th>
                            <th pSortableColumn="component">{{'COMPONENT_NAME'| translate}}
                                <p-columnFilter type="text" field="component" display="menu"></p-columnFilter>
                                <p-sortIcon field="component"></p-sortIcon>
                            </th>
                            <th pSortableColumn="size">{{'SIZE'| translate}}
                                <p-columnFilter type="text" field="size" display="menu"></p-columnFilter>
                                <p-sortIcon field="size"></p-sortIcon>
                            </th>
                            <th pSortableColumn="Price">{{'PRICE'| translate}}
                                <p-columnFilter type="text" field="Price" display="menu"></p-columnFilter>
                                <p-sortIcon field="Price"></p-sortIcon>
                            </th>
                            <th pSortableColumn="EstimatedQuantity">{{'ESTIMATED_QUANTITY'| translate}}
                                <p-columnFilter type="text" field="EstimatedQuantity" display="menu"></p-columnFilter>
                                <p-sortIcon field="EstimatedQuantity"></p-sortIcon>
                            </th>
                            <th pSortableColumn="BilledQuantity">{{'BILLED_QUANTITY'| translate}}
                                <p-columnFilter type="text" field="BilledQuantity" display="menu"></p-columnFilter>
                                <p-sortIcon field="BilledQuantity"></p-sortIcon>
                            </th>
                            <th pSortableColumn="ActualQuantity">{{'ACTUAL_QUANTITY'| translate}}
                                <p-columnFilter type="text" field="ActualQuantity" display="menu"></p-columnFilter>
                                <p-sortIcon field="ActualQuantity"></p-sortIcon>
                            </th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-i="rowIndex">
                        <tr [ngStyle]="{'background-color': product?.ActualQuantity  ? '#e6ffe6' : '#ffffff'}">
                            <td>{{product?.ProgrammeName}}</td>
                            <td>{{product?.CompId}}</td>
                            <td>{{product?.CatId}}</td>
                            <td>{{product?.SizeId}}</td>
                            <td>{{product?.component}}</td>
                            <td>{{product?.size}}</td>
                            <td>{{product?.Price}}</td>
                            <td>{{product?.EstimatedQuantity}}</td>
                            <td>{{product?.BilledQuantity}}</td>
                            <td>{{product?.ActualQuantity}}</td>
                            <td>
                                <button *ngIf="editBilledData" pButton pRipple icon="pi pi-pencil"
                                    class="p-button-rounded p-button-success mr-2"
                                    (click)="editFinanceComponentDialog(product, i)"></button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            {{'IN_TOTAL_THERE_ARE'| translate}}  {{physicalVerficationBilledData ? physicalVerficationBilledData.length :
                            0 }}  {{'COMPONENT_DETAILS_ADDED'| translate}}.
                        </div>
                    </ng-template>
                </p-table>
            </div>
        </p-card>
    </div>
    <div class="mt-2">
        <div class="card pv-cal-card">
            <form [formGroup]="financeCalculationsForm">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-4">
                        <label htmlFor="physicallyVerified">{{'PHYSICALLY_VERIFIED'| translate}}</label>
                        <p-dropdown [options]="physicallyVerifiedOptions" formControlName="physicallyVerified"
                            optionLabel="name" optionValue="code"></p-dropdown>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="totalEstimateAmount">{{'TOTAL_ESTIMATED_COST'| translate}}</label>
                        <input class="bNone" readonly formControlName="totalEstimateAmount" pInputText
                            id="totalEstimateAmount" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls.totalEstimateAmount.errors }" />
                        <div *ngIf="isSubmitted && financeCalculationFormControls.totalEstimateAmount.errors"
                            class="invalid-feedback">
                            <div *ngIf="financeCalculationFormControls.totalEstimateAmount.errors.required">{{'TOTAL_ESTIMATED_COST_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="BoqDiscountRate">{{'DISCOUNT_RATE'| translate}}</label>
                        <input class="bNone" readonly formControlName="BoqDiscountRate" pInputText
                            id="BoqDiscountRate" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls.BoqDiscountRate.errors }" />
                        <div *ngIf="isSubmitted && financeCalculationFormControls.BoqDiscountRate.errors"
                            class="invalid-feedback">
                            <div *ngIf="financeCalculationFormControls.BoqDiscountRate.errors.required">{{'TOTAL_ESTIMATED_COST_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>

                    <!-- for Portable SPrinkler hide the Transportaion Cost
                    for Drip Irrigation & Mini - input field to enter the Area Survey & Transportation Cost multiply by 2500 -->
                    <div *ngIf="editBilledData" class="field col-12 md:col-4">
                        <label htmlFor="MIArea">{{'AREA_SURVEYED_(IN_ACRE)'| translate}}</label>
                        <input formControlName="MIArea" pInputText id="MIArea" type="number" min="1" max="physicalVerficationData?.MIArea" onwheel="this.blur()" (input)="changeMiArea()"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls?.MIArea?.errors }" />
                        <div *ngIf="isSubmitted || financeCalculationFormControls?.MIArea?.errors || financeCalculationFormControls?.MIArea?.touched"
                            class="invalid-feedback">
                            <div *ngIf="financeCalculationFormControls?.MIArea?.errors?.required">
                                {{'AREA_SURVEYED_IS_REQUIRED'| translate}}
                            </div>
                            <div *ngIf="financeCalculationFormControls?.MIArea?.errors?.min">
                                {{'AREA_MUST_GREATER_OR_EQUAL_TO_1'| translate}}
                            </div>
                        </div>
                        <small class="p-error"
                            *ngIf="greaterThan(financeCalculationFormControls?.MIArea?.value,physicalVerficationData?.MIArea)">{{'ACTUAL_AREA_SURVEYED_CANNOT_BE_GREATER_THAN_BILLED_AREA_SURVEYED'| translate}}{{' '+ physicalVerficationData?.MIArea}}</small>
                    </div>

                    <!-- && ((physicalVerficationBilledData[0]?.ProgrammeName == 'Mini Sprinkler') || (physicalVerficationBilledData[0]?.ProgrammeName == 'Drip Irrigation'))" -->
                    <div *ngIf="(editBilledData)" class="field col-12 md:col-4">
                        <label htmlFor="transportationAmount">{{'TRANSPORTATION_AMOUNT/OTHER_ACCESSORIES_&_FITTING_CHARGES(MI_AREA*RS.2500)'| translate}}</label>
                        <input readonly class="bNone" formControlName="transportationAmount" pInputText
                            id="transportationAmount" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls.transportationAmount.errors }" />
                        <div *ngIf="isSubmitted && financeCalculationFormControls.transportationAmount.errors"
                            class="invalid-feedback">
                            <div *ngIf="financeCalculationFormControls.transportationAmount.errors.required">
                                {{'TRANSPORTATION_AMOUNT/OTHER_ACCESSORIES_&_FITTING_CHARGES_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="totalBilledAmount">{{'TOTAL_BILLED_AMOUNT'| translate}}</label>
                        <input class="bNone" readonly formControlName="totalBilledAmount" pInputText
                            id="totalBilledAmount" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls.totalBilledAmount.errors }" />
                        <div *ngIf="isSubmitted && financeCalculationFormControls.totalBilledAmount.errors"
                            class="invalid-feedback">
                            <div *ngIf="financeCalculationFormControls.totalBilledAmount.errors.required">{{'TOTAL_BILLED_AMOUNT_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="billedTransportationAmount">{{'BILLED_TRANSPORTATION_AMOUNT'| translate}}</label>
                        <input class="bNone" readonly formControlName="billedTransportationAmount" pInputText
                            id="billedTransportationAmount" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls.billedTransportationAmount.errors }" />
                        <div *ngIf="isSubmitted && financeCalculationFormControls.billedTransportationAmount.errors"
                            class="invalid-feedback">
                            <div *ngIf="financeCalculationFormControls.billedTransportationAmount.errors.required">
                                {{'BILLED_TRANSPORTATION_AMOUNT_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="totalCost">{{'TOTAL_COST_FOR_PHYSICAL_VERIFICATION'| translate}}</label>
                        <input class="bNone" readonly formControlName="totalCost" pInputText id="totalCost" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls.totalCost.errors }" />
                        <div *ngIf="isSubmitted && financeCalculationFormControls.totalCost.errors"
                            class="invalid-feedback">
                            <div *ngIf="financeCalculationFormControls.totalCost.errors.required">
                                {{'TOTAL_COST_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="maximumSubsidy">{{'CALCULATED_MAXIMUM_SUBSIDY_@_85%'| translate}}</label>
                        <input class="bNone" readonly formControlName="maximumSubsidy" pInputText id="maximumSubsidy"
                            type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls.maximumSubsidy.errors }" />
                        <div *ngIf="isSubmitted && financeCalculationFormControls.maximumSubsidy.errors"
                            class="invalid-feedback">
                            <div *ngIf="financeCalculationFormControls.maximumSubsidy.errors.required">{{'MAXIMUM_SUBSIDY_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="farmerShare">{{'CALCULATED_FARMER_SHARE_@_15%'| translate}}</label>
                        <input class="bNone" readonly formControlName="farmerShare" pInputText id="farmerShare"
                            type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls.farmerShare.errors }" />
                        <div *ngIf="isSubmitted && financeCalculationFormControls.farmerShare.errors"
                            class="invalid-feedback">
                            <div *ngIf="financeCalculationFormControls.farmerShare.errors.required">{{'FARMER_SHARE_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="farmerInitialDeposit">{{'AMOUNT_DEPOSIT_BY_FARMER'| translate}}</label>
                        <input class="bNone" readonly formControlName="farmerInitialDeposit" pInputText
                            id="farmerInitialDeposit" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls.farmerInitialDeposit.errors }" />
                        <div *ngIf="isSubmitted && financeCalculationFormControls.farmerInitialDeposit.errors"
                            class="invalid-feedback">
                            <div *ngIf="financeCalculationFormControls.farmerInitialDeposit.errors.required">{{'AMOUNT_DEPOSIT_BY_FARMER_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="ChallanType">{{'CHALLAN_TYPE'| translate}}</label>
                        <input class="bNone" readonly formControlName="ChallanType" pInputText id="ChallanType"
                            type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls.ChallanType.errors }" />
                        <div *ngIf="isSubmitted && financeCalculationFormControls.ChallanType.errors"
                            class="invalid-feedback">
                            <div *ngIf="financeCalculationFormControls.ChallanType.errors.required">{{'CHALLAN_TYPE_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <div>
                            <label htmlFor="ChallanType">{{'BILL_COPY'| translate}}</label>
                        </div>
                        <div style="display: inline-block;">
                            <div class="m-3">
                                <a *ngIf="physicalVerficationData?.BillUploadedByVendor" target="_blank" [href]="physicalVerficationData?.BillUploadedByVendor">
                                    {{'VIEW'| translate}}
                                </a>
                                <div *ngIf="!physicalVerficationData?.BillUploadedByVendor">
                                    {{'NULL'| translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <div>
                            <label htmlFor="ChallanType">{{'LAND_MAP'| translate}}</label>
                        </div>
                        <div style="display: inline-block;">
                            <div class="m-3">
                                <a *ngIf="physicalVerficationData?.LandMapPath" target="_blank" [href]="physicalVerficationData?.LandMapPath">
                                    {{'VIEW'| translate}}
                                </a>
                                <div *ngIf="!physicalVerficationData?.LandMapPath">
                                    {{'NULL'| translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <div>
                            <label htmlFor="ChallanType">{{'SIGNATURE'| translate}}</label>
                        </div>
                        <div style="display: inline-block;">
                            <div class="m-3">
                                <p-image 
                                    [src]="physicalVerficationData?.SignaturePathEst" 
                                    [previewImageSrc]="physicalVerficationData?.SignaturePathEst"
                                    alt="100" 
                                    width="100" 
                                    [preview]="true"></p-image>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-fluid p-formgrid grid mt-5" *ngIf="canEditMIData">
                    <div class="field col-12 md:col-4">
                        <label htmlFor="SubsidyToFarmerAmount">{{'SUBSIDY_TO_FARMER'| translate}}</label>
                        <input formControlName="SubsidyToFarmerAmount" pInputText id="SubsidyToFarmerAmount" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls.SubsidyToFarmerAmount.errors }" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="SubsidyToVendorAmount">{{'PAYMENT_TO_VENDOR'| translate}}</label>
                        <input formControlName="SubsidyToVendorAmount" pInputText id="SubsidyToVendorAmount" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls.SubsidyToVendorAmount.errors }" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="FarmerRefundAmount">{{'REFUND_TO_FARMER'| translate}}</label>
                        <input formControlName="FarmerRefundAmount" pInputText id="FarmerRefundAmount" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls.FarmerRefundAmount.errors }" />
                    </div>
                    <!-- <div class="field col-12 md:col-3">
                        <label htmlFor="farmerShare">Farmer Share @ 15%</label>
                        <input formControlName="farmerShare" pInputText id="farmerShare" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && financeCalculationFormControls.farmerShare.errors }" />
                    </div> -->
                </div>
            </form>
            <div *ngIf="subSsScTopUpAmount" class="p-fluid p-formgrid grid proData-new-sub">
                <div class="field col-12 md:col-3 sub-header" style="display: flex; flex-wrap:wrap">
                    <p>{{ 'Recommended Calculation:-' }}</p>
                </div>
                
                <div class="field col-12 md:col-2">
                    <label>{{'STATE_SHARE_AMOUNT'| translate}} :</label>
                    <p><label>Rs. {{ subSsScTopUpAmount.StateShareRec | number : '1.0-2'}}/-</label></p>
                </div>
                <div class="field col-12 md:col-2">
                    <label>{{'CENTER_SHARE_AMOUNT'| translate}} :</label>
                    <p><label>Rs. {{ subSsScTopUpAmount.CenterShareRec | number : '1.0-2'}}/-</label></p>
                </div>
                <div class="field col-12 md:col-2">
                    <label>{{'TOP_UP_AMOUNT'| translate}} :</label>
                    <p><label>Rs. {{ subSsScTopUpAmount.TopUpRec | number : '1.0-2'}}/-</label></p>
                </div>
            </div>
        </div>
    </div>
    <div class="card proDataCalculation">
        <!-- <div> -->
        <!-- pro data calculations -->
        <div class="my-2 proDataButton">
            <button (click)="proDataCalculation()" pButton pRipple type="submit"
            label="{{'VIEW_PRO_DATA_MAX_SUBSIDY_CAL'| translate}}" class="p-button-info mr-2 mb-2"></button>
        </div>
        <!-- <div *ngIf="showProDataCalError" class="invalid-feedback mb-2">
                <div *ngIf="finalEstimationControls?.rowSpacing?.errors?.required">Row Spacing is
                    required
                </div>
                <div *ngIf="finalEstimationControls?.plantSpacing?.errors?.required">Plant Spacing is
                    required
                </div>
                <div *ngIf="finalEstimationControls?.MIArea?.errors?.required">MIArea Spacing is
                    required
                </div>
            </div> -->

        <div *ngIf="isProDataCalculated" class="p-fluid p-formgrid grid card proData">
            <div class="field col-12 md:col-3 pro-data-header" style="display: flex; flex-wrap:wrap">
                <p>{{ 'State Guidelines' }}</p>
            </div>
            <div class="field col-12 md:col-1">
                <label htmlFor="criteria" class="sub-header">{{'Criteria'| translate}}</label>
                <!-- <p><label>{{ proCalculatedData.OutputNewCalc }}</label></p> -->
            </div>
            <div class="field col-12 md:col-2 sub-card">
                <label htmlFor="pro-data">{{'Row Spacing'| translate}} :</label>
                <p><label>{{ proCalculatedData.RowSpacing }}</label></p>
            </div>
            <div class="field col-12 md:col-2 sub-card">
                <label htmlFor="pro-data">{{'Plant Spacing'| translate}} :</label>
                <p><label>{{ proCalculatedData.PlantSpacing }}</label></p>
            </div>
            <div class="field col-12 md:col-2 sub-card">
                <label htmlFor="pro-data">{{'Area (Ha.)'| translate}} :</label>
                <p><label>{{ proCalculatedData.Area }}</label></p>
            </div>

            <div class="field col-12 md:col-3">
                <label htmlFor="pro-data">{{'PRO_DATA_MAX_SUBSIDY_FORMULA'| translate}} :</label>
                <p><label>{{ proCalculatedData.Formula }}</label></p>
            </div>

            <div class="field col-12 md:col-3">
                <label htmlFor="output">{{'OUTPUT'| translate}} :</label>
                <p><label>{{ proCalculatedData.Output }}</label></p>
            </div>

            <div class="field col-12 md:col-2">
                <label htmlFor="amount">{{'Unit Cost'| translate}} :</label>
                <p><label>Rs. {{ proCalculatedData.Amount | number : '1.2-2'}}/-</label></p>
            </div>

            <div class="field col-12 md:col-1">
                <label htmlFor="maxSubsidy">{{'MAX_SUBSIDY_AMOUNT'| translate}} :</label>
                <p><label>Rs. {{ proCalculatedData.maxSubsidy }}/-</label></p>
            </div>

            <div class="field col-12 md:col-1">
                <label htmlFor="transportAmount">{{'TRANSPORT_AMOUNT'| translate}} :</label>
                <p><label>Rs. {{ proCalculatedData.TransportAmount }}/-</label></p>
            </div>

            <div class="field col-12 md:col-2">
                <label htmlFor="result">{{'RESULT'| translate}} :</label>
                <p><label>{{ proCalculatedData.Result }}</label></p>
            </div>

        </div>

        <div *ngIf="isProDataCalculated" class="p-fluid p-formgrid grid card proData-new">
            <div class="field col-12 md:col-3 pro-data-header" style="display: flex; flex-wrap:wrap">
                <p>{{ 'Centre Guidelines' }}</p>
            </div>
            <div class="field col-12 md:col-1">
                <label htmlFor="criteria" class="sub-header">{{'Criteria'| translate}}</label>
                <!-- <p><label>{{ proCalculatedData.OutputNewCalc }}</label></p> -->
            </div>
            <div class="field col-12 md:col-2 sub-card">
                <label htmlFor="pro-data">{{'Row Spacing'| translate}} :</label>
                <p><label>{{ proCalculatedData.RowSpacing }}</label></p>
            </div>
            <div class="field col-12 md:col-2 sub-card">
                <label htmlFor="pro-data">{{'Plant Spacing'| translate}} :</label>
                <p><label>{{ proCalculatedData.PlantSpacing }}</label></p>
            </div>
            <div class="field col-12 md:col-2 sub-card">
                <label htmlFor="pro-data">{{'Area (Ha.)'| translate}} :</label>
                <p><label>{{ proCalculatedData.Area }}</label></p>
            </div>
            <div class="field col-12 md:col-3">
                <label htmlFor="pro-data">{{'PRO_DATA_MAX_SUBSIDY_FORMULA'| translate}} :</label>
                <p><label>{{ proCalculatedData.FormulaNewCalc }}</label></p>
            </div>

            <div class="field col-12 md:col-3">
                <label htmlFor="output">{{'OUTPUT'| translate}} :</label>
                <p><label>{{ proCalculatedData.OutputNewCalc }}</label></p>
            </div>

            <div class="field col-12 md:col-2">
                <label htmlFor="amount">{{'Unit Cost'| translate}} :</label>
                <p><label>Rs. {{ proCalculatedData.AmountNewCalc | number : '1.2-2'}}/-</label></p>
            </div>

            <div class="field col-12 md:col-1">
                <label htmlFor="maxSubsidy">{{'MAX_SUBSIDY_AMOUNT'| translate}} :</label>
                <p><label>Rs. {{ proCalculatedData.maxSubsidyNewCalc }}/-</label></p>
            </div>

            <!-- <div class="field col-12 md:col-1">
                <label htmlFor="transportAmount">{{'TRANSPORT_AMOUNT_NEW'| translate}} :</label>
                <p><label>Rs. {{ proCalculatedData.TransportAmount }}/-</label></p>
            </div> -->

            <div class="field col-12 md:col-2">
                <label htmlFor="result">{{'RESULT'| translate}} :</label>
                <p><label>{{ proCalculatedData.ResultNewCalc }}</label></p>
            </div>
        </div>

        <div *ngIf="oldSsScTopUpAmount">
            <div class="card proDataCalculation view-amount-card">
                <div class="my-2 proDataButton">
                    <button (click)="viewSsScTopup()" pButton pRipple type="submit"
                    label="{{'VIEW_SS_CS_TOPUP'| translate}}" class="p-button-info mr-2 mb-2"></button>
                </div>
        
                <div *ngIf="oldSsScTopUpAmount" class="p-fluid p-formgrid grid proData">
                    <div class="field col-12 md:col-3 pro-data-header" style="display: flex; flex-wrap:wrap">
                        <p>{{ 'State Guidelines' }}</p>
                    </div>
                    <div class="field col-12 md:col-1">
                        <label htmlFor="criteria" class="sub-header">{{'Criteria'| translate}}</label>
                        <!-- <p><label>{{ proCalculatedData.OutputNewCalc }}</label></p> -->
                    </div>
                    <div class="field col-12 md:col-2 sub-card">
                        <label htmlFor="pro-data">{{'Caste'| translate}} :</label>
                        <p><label>{{ oldSsScTopUpAmount.CasteDesc }}</label></p>
                    </div>
                    <div class="field col-12 md:col-2 sub-card">
                        <label htmlFor="pro-data">{{'Farmer Type'| translate}} :</label>
                        <p><label>{{ oldSsScTopUpAmount.farmercategory }}</label></p>
                    </div>
                    <div class="field col-12 md:col-2 sub-card">
                        <label htmlFor="pro-data">{{'Programme Name'| translate}} :</label>
                        <p><label>{{ oldSsScTopUpAmount.subsidyType }}</label></p>
                    </div>
                    <div class="field col-12 md:col-3">
                    </div>
                    <div class="field col-12 md:col-3">
                        <label htmlFor="pro-data">{{'STATE_SHARE_AMOUNT'| translate}} :</label>
                        <p><label>Rs. {{ oldSsScTopUpAmount.StateShareOld | number : '1.2-2'}}/-</label></p>
                    </div>
        
                    <div class="field col-12 md:col-3">
                        <label htmlFor="output">{{'CENTER_SHARE_AMOUNT'| translate}} :</label>
                        <p><label>Rs. {{ oldSsScTopUpAmount.CenterShareOld | number : '1.2-2'}}/-</label></p>
                    </div>
        
                    <div class="field col-12 md:col-2">
                        <label htmlFor="amount">{{'TOP_UP_AMOUNT'| translate}} :</label>
                        <p><label>Rs. {{ oldSsScTopUpAmount.TopUpOld | number : '1.2-2'}}/-</label></p>
                    </div>
        
                </div>

                <div *ngIf="newSsScTopUpAmount" class="p-fluid p-formgrid grid proData-new">
                    <div class="field col-12 md:col-3 pro-data-header" style="display: flex; flex-wrap:wrap">
                        <p>{{ 'Center Guidelines' }}</p>
                    </div>
                    
                    <div class="field col-12 md:col-3">
                        <label htmlFor="pro-data">{{'STATE_SHARE_AMOUNT'| translate}} :</label>
                        <p><label>Rs. {{ newSsScTopUpAmount.StateShareNew | number : '1.2-2'}}/-</label></p>
                    </div>
        
                    <div class="field col-12 md:col-3">
                        <label htmlFor="output">{{'CENTER_SHARE_AMOUNT'| translate}} :</label>
                        <p><label>Rs. {{ newSsScTopUpAmount.CenterShareNew | number : '1.2-2'}}/-</label></p>
                    </div>
        
                    <div class="field col-12 md:col-2">
                        <label htmlFor="amount">{{'TOP_UP_AMOUNT'| translate}} :</label>
                        <p><label>Rs. {{ newSsScTopUpAmount.TopUpNew | number : '1.2-2'}}/-</label></p>
                    </div>
                    <div class="field col-12 md:col-12 note-text" style="display: flex; flex-wrap:wrap">
                        <p>Note: Calculation of Centre Share, State Share and State Topup is as Under: <br> 
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Farmer Category: Big  60% CS AND 40% SS of (Recommended Unit Cost x 0.45) & Topup = (Recommended Unit Cost x 0.40).<br> 
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Farmer Category: Other  60% CS AND 40% SS of (Recommended Unit Cost x 0.55) & Topup = (Recommended Unit Cost x 0.30).</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div>
        <div *ngIf="userRole=='DD Associate'" class="card" reflow="true">
            <div *ngIf="viewWorkFlowAllStatus">
                <app-work-flow-all-status [applicationId]="physicalVerficationData?.AppID"></app-work-flow-all-status>
            </div>
        
            <button *ngIf="!viewWorkFlowAllStatus" pButton type="button" label="{{'VIEW_APPLICATION_STATUS' | translate}}"
                class="p-button-secondary" (click)="workFlowAllStatus()"></button>
        </div>
        <div class="card" *ngIf="isProDataCalculated">
            <button (click)="onFinanceCalculationFormGoBack()" pButton pRipple type="button" label="Back"
                class="p-button-success mr-2 mb-2"></button>
            <button *ngIf="userRole!=='DD Associate'"  (click)="onFinanceCalculationFormSubmit()" pButton pRipple type="button" label="Save & Next"
                class="p-button-success mr-2 mb-2"></button>
                <button *ngIf="userRole=='DD Associate'" (click)="onFinanceCalculationFormSubmit()" pButton pRipple type="button" label="Save"
                class="p-button-success mr-2 mb-2"></button>    
        </div>
        <div class="card" *ngIf="isSubmitEnable">
            <app-attachment [data]="data"></app-attachment>
        </div>
    </div>
</div>


<p-dialog [(visible)]="showFinanceComponentDialog" [style]="{width: '800px'}" header="Edit Component Finance Details"
    [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
        <div class="p-fluid p-formgrid grid">
            <div class="field col-4">
                <label for="ProgrammeName">{{'PROGRAMME_NAME'| translate}}</label>
                <input readonly type="text" pInputText id="ProgrammeName"
                    [(ngModel)]="selectedFinanceComponent.ProgrammeName" required />
                <small class="p-error" *ngIf="submitted && !selectedFinanceComponent.ProgrammeName">{{'PROGRAMME_NAME_IS_REQUIRED'| translate}}.</small>
            </div>
            <div class="field col-4">
                <label for="compId">{{'COMPONENT_ID'| translate}}</label>
                <input readonly type="text" pInputText id="compId" [(ngModel)]="selectedFinanceComponent.CompId"
                    required />
                <small class="p-error" *ngIf="submitted && !selectedFinanceComponent.CompId">{{'COMPONENT_ID_IS_REQUIRED'| translate}}.</small>
            </div>
            <div class="field col-4">
                <label for="catId">{{'CAT_ID'| translate}}</label>
                <input readonly type="text" pInputText id="catId" [(ngModel)]="selectedFinanceComponent.CatId"
                    required />
                <small class="p-error" *ngIf="submitted && !selectedFinanceComponent.CatId">{{'CATEGORY_ID_IS_REQUIRED'| translate}}.</small>
            </div>
            <div class="field col-4">
                <label for="sizeId">{{'SIZE_ID'| translate}}</label>
                <input readonly type="text" pInputText id="sizeId" [(ngModel)]="selectedFinanceComponent.SizeId"
                    required />
                <small class="p-error" *ngIf="submitted && !selectedFinanceComponent.SizeId">{{'SIZE_ID_IS_REQUIRED'| translate}}.</small>
            </div>
            <div class="field col-4">
                <label for="component">{{'COMPONENT_NAME'| translate}}</label>
                <input readonly type="text" pInputText id="component" [(ngModel)]="selectedFinanceComponent.component"
                    required />
                <small class="p-error" *ngIf="submitted && !selectedFinanceComponent.component">{{'COMPONENT_NAME_IS_REQUIRED'| translate}}.</small>
            </div>
            <div class="field col-4">
                <label for="size">{{'SIZE'| translate}}</label>
                <input readonly type="text" pInputText id="size" [(ngModel)]="selectedFinanceComponent.size" required />
                <small class="p-error" *ngIf="submitted && !selectedFinanceComponent.size">{{'SIZE_IS_REQUIRED'| translate}}.</small>
            </div>
            <div class="field col-4">
                <label for="price">{{'PRICE'| translate}}</label>
                <input readonly type="text" pInputText id="price" [(ngModel)]="selectedFinanceComponent.Price"
                    required />
                <small class="p-error" *ngIf="submitted && !selectedFinanceComponent.Price">{{'PRICE_IS_REQUIRED'| translate}}.</small>
            </div>
            <div class="field col-4">
                <label for="estQty">{{'ESTIMATED_QUANTITY'| translate}}</label>
                <input readonly type="text" pInputText id="estQty"
                    [(ngModel)]="selectedFinanceComponent.EstimatedQuantity" required />
                <small class="p-error" *ngIf="submitted && !selectedFinanceComponent.EstimatedQuantity">{{'ESTIMATED_QUANTITY_IS_REQUIRED'| translate}}.</small>
            </div>
            <div class="field col-4">
                <label for="billedQty">{{'BILLED_QUANTITY'| translate}}</label>
                <input readonly type="text" pInputText id="billedQty"
                    [(ngModel)]="selectedFinanceComponent.BilledQuantity" required />
                <small class="p-error" *ngIf="submitted && !selectedFinanceComponent.BilledQuantity">{{'BILLED_QUANTITY_IS_REQUIRED'| translate}}.</small>
            </div>
            <!-- <div class="field col-4" *ngIf="selectedFinanceComponent.inventory.length==0" > -->
            <div class="field col-4">
                <label for="actualQty">{{'ACTUAL_QUANTITY'| translate}}</label>
                <input type="text" pInputText id="actualQty" [(ngModel)]="selectedFinanceComponent.ActualQuantity" (keypress)="stripText($event)"
                    required autofocus />
                <small class="p-error" *ngIf="submitted && !selectedFinanceComponent.ActualQuantity">{{'ACTUAL_QUANTITY_IS_REQUIRED'| translate}}.</small>
                <small class="p-error"
                    *ngIf="greaterThan(selectedFinanceComponent.ActualQuantity,selectedFinanceComponent.BilledQuantity)">{{'ACTUAL_QUANTITY_SHOULD_BE_LESS_THAN_BILLED_QUANTITY'| translate}}.</small>
                <small class="p-error" *ngIf="(selectedFinanceComponent.ActualQuantity) < 0">Actual
                    {{'QUANTITY_SHOULD_BE_GREATER_THAN_0'| translate}}</small>
            </div>
            <!-- <div class="field col-4" *ngIf="selectedFinanceComponent.inventory.length>0" style="width: 100%;" > -->
            <div class="field col-4" *ngIf="false" style="width: 100%;" >
                <div class="mi-survey-container" >
                    <!-- <p-card styleClass="p-card-shadow"> -->
                    <div class="card dashboardTable">
                      <p-table #miSurvey [value]="selectedFinanceComponent?.inventory" [(selection)]="inventoryRowFilteredData"
                        dataKey="batchNumber_lotNo" (onRowSelect)="onInventoryRowSelect($event)"
                        (onRowUnselect)="onInventoryRowUnselect($event)" (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
                        [rows]="10" [paginator]="true" [globalFilterFields]="[
                                'batchNumber',
                                'lotNo',
                                'remainingQuantity', 
                                'quantityUsed',
                                ]" responsiveLayout="scroll" [rowHover]="true"
                        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                        [showCurrentPageReport]="true" [paginator]="true" [rows]="10" [selectionPageOnly]="true">
                
                        <ng-template pTemplate="header">
                
                          <tr>
                            <th style="width: 3rem">
                              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </th>
                            <th pSortableColumn="batchNumber">{{'BATCH_NUMBER'| translate}}
                                <p-columnFilter type="text" field="batchNumber" display="menu"></p-columnFilter>
                                <p-sortIcon field="batchNumber"></p-sortIcon>
                            </th>
                            <th pSortableColumn="lotNo">{{'LOT_NO'| translate}}
                                <p-columnFilter type="text" field="lotNo" display="menu"></p-columnFilter>
                                <p-sortIcon field="lotNo"></p-sortIcon>
                            </th>
                            <th pSortableColumn="remainingQuantity">{{'REMAINING_QUANTITY'| translate}}
                                <p-columnFilter type="text" field="remainingQuantity" display="menu"></p-columnFilter>
                                <p-sortIcon field="remainingQuantity"></p-sortIcon>
                            </th>
                            <th pSortableColumn="quantityUsed">{{'QUANTITY_USED'| translate}}
                                <p-columnFilter type="text" field="quantityUsed" display="menu"></p-columnFilter>
                                <p-sortIcon field="quantityUsed"></p-sortIcon>
                            </th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                          <tr>
                            <td>
                              <p-tableCheckbox [value]="product"></p-tableCheckbox>
                            </td>
                            <td>{{product.batchNumber}}</td>
                            <td>{{product.lotNo}}</td>
                            <td>{{product.remainingQuantity}}</td>
                            <td pEditableColumn>
                              <p-cellEditor>
                                <ng-template pTemplate="input">
                                  <input pInputText type="number" min="0" required [(ngModel)]="product.quantityUsed" (change)="onEditComplete($event)"
                                    [style]="{'background-color': 'rgb(211, 209, 209)'}"
                                    [ngClass]="{
                                      'ng-invalid ng-dirty': product.quantityUsed < 0 || product.quantityUsed > product.remainingQuantity }" />
                                  <div class="invalid-feedback" *ngIf="product.quantityUsed < 0">
                                    {{'Must not be negative'| translate}}
                                  </div>
                                  <div class="invalid-feedback" *ngIf="product.quantityUsed > product.remainingQuantity">
                                    {{'Qunatity must not be greater than Remaining Quantity'| translate}} 
                                  </div>
                                </ng-template>
                                <ng-template pTemplate="output">
                                  {{ product.quantityUsed }}
                                </ng-template>
                              </p-cellEditor>
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                          <div class="flex align-items-center justify-content-between">
                            {{'IN_TOTAL_THERE_ARE'| translate}} {{selectedFinanceComponent?.inventory ? selectedFinanceComponent?.inventory?.length : 0 }}
                            {{'INVENTORY'| translate}}
                          </div>
                        </ng-template>
                      </p-table>
                    </div>
                    <div class="card" *ngIf="selectedFinanceComponent?.inventory?.length">
                      <h5 [style]="{color: 'rgb(168, 32, 32)'}"><b>{{'TOTAL_QUANTITY_USED'| translate}} {{ totalQuantityUsed }} </b></h5>
                      <div class="d-flex" *ngIf="totalQuantityUsed > selectedFinanceComponent.BilledQuantity">
                        <p class="d-flex justify-content-center" [style]="{color: 'red'}"><b>{{'TOTAL_SELECTED_QUANTITY_USED_MUST_NOT_BE_GREATER_THAN_BILLED_QUANTITY'| translate}}</b></p>
                      </div>
                    </div>
                    
                    <!-- </p-card> -->
                  </div>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text"
            (click)="hideFinanceComponentDialog()"></button>
        <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text" [disabled]="totalQuantityUsed > selectedFinanceComponent.BilledQuantity"
            (click)="saveFinanceComponent()"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>